import React from 'react';
import { Clock, Eye, CheckCircle, Star, ShieldCheck, AlertTriangle, ArrowRight } from 'lucide-react';
export function Advertorial() {
  return <div className="min-h-screen bg-white font-sans text-[#1a1a1a] selection:bg-[#d4a574] selection:text-white" data-id="element-2">
      {/* Top Bar */}
      <div className="bg-[#1a1a1a] text-white text-xs py-1 px-4 text-center tracking-widest uppercase font-semibold" data-id="element-3">
        Advertorial
      </div>

      {/* Newspaper Header */}
      <header className="border-b-4 border-black mb-8 pt-6 pb-4 px-4 max-w-5xl mx-auto" data-id="element-4">
        {/* Top meta line */}
        <div className="text-center mb-3" data-id="element-5">
          <div className="text-xs font-bold tracking-widest uppercase text-gray-600" data-id="element-6">
            Independent Veterinary Investigations Since 1998
          </div>
        </div>

        {/* Date line */}
        <div className="text-center mb-4 pb-3 border-b border-gray-300" data-id="element-7">
          <div className="text-xs font-bold tracking-widest uppercase text-gray-600" data-id="element-8">
            Vol. 42, No. 8 • Friday, January 3, 2026
          </div>
        </div>

        {/* Publication name */}
        <h1 className="text-4xl md:text-6xl font-serif font-black text-center tracking-tight mb-4 uppercase" data-id="element-9">
          Pet Health Weekly
        </h1>

        {/* Section labels */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm font-bold uppercase tracking-wider border-t border-b border-black py-2" data-id="element-10">
          <span className="bg-red-600 text-white px-3 py-1" data-id="element-11">
            Investigative Report
          </span>
          <span className="text-center" data-id="element-12">Canine Health & Wellness Section</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 pb-20" data-id="element-13">
        {/* Article Header */}
        <article data-id="element-14">
          <h1 className="text-3xl md:text-5xl font-serif font-bold leading-tight mb-6 text-gray-900" data-id="element-15">
            Veterinary Rehab Specialist Investigates: Do Thermal Reflection Pads
            Actually Help Dog Arthritis, or Is It Another Pet Industry Scam?
          </h1>

          <div className="flex flex-col md:flex-row items-start md:items-center justify-between border-y border-gray-300 py-4 mb-8 gap-4" data-id="element-16">
            <div className="flex items-center gap-3" data-id="element-17">
              <div className="w-12 h-12 bg-gray-300 rounded-full overflow-hidden shrink-0" data-id="element-18">
                <img src="https://cdn.magicpatterns.com/uploads/idVRusXKSJusmFHJbYQzeZ/29cd39da-ce5d-47f5-9f37-392f625866bf.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-19" />
              </div>
              <div data-id="element-20">
                <div className="font-bold text-lg flex items-center gap-1" data-id="element-21">
                  Dr. Sarah Mitchell, DVM, CCRP
                  <ShieldCheck className="w-4 h-4 text-blue-600" fill="currentColor" stroke="white" data-id="element-22" />
                </div>
                <div className="text-sm text-gray-600" data-id="element-23">
                  Veterinary rehabilitation specialist • 18 years clinical
                  experience
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-500 font-medium" data-id="element-24">
              <div className="flex items-center gap-1" data-id="element-25">
                <Clock className="w-4 h-4" data-id="element-26" />
                14 min read
              </div>
              <div className="flex items-center gap-1" data-id="element-27">
                <Eye className="w-4 h-4" data-id="element-28" />
                31,542 views
              </div>
            </div>
          </div>

          {/* Intro */}
          <p className="text-xl leading-relaxed mb-8 font-serif text-gray-800 first-letter:text-5xl first-letter:font-bold first-letter:float-left first-letter:mr-2 first-letter:mt-[-4px]" style={{
          marginBottom: '20px'
        }} data-id="element-29">
            After 18 years in veterinary rehabilitation, I've tested every
            arthritis product on the market. So when colleagues started
            recommending "thermal reflection pads," I assumed it was another
            overpriced pet bed scam. What I discovered during my 8-month
            investigation will change how you think about canine joint pain.
          </p>

          <figure className="mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-30">
            <img src="https://cdn.magicpatterns.com/uploads/m9jgYnZMbLfLngS71HxCLN/bba612d8-69a0-4aaf-be19-ffa335610a8b.png" alt="Dr. Sarah Mitchell in rehabilitation facility with Golden Retriever" className="w-full h-auto grayscale-[20%] contrast-[1.1]" data-id="element-31" />
            <figcaption className="text-xs text-gray-500 p-2 italic font-serif border-t border-gray-200 mt-1" data-id="element-32">
              Dr. Sarah Mitchell, DVM, CCRP has spent nearly two decades working
              in canine rehabilitation and post-surgical recovery.
            </figcaption>
          </figure>

          <div className="prose prose-lg max-w-none prose-headings:font-serif prose-headings:font-bold prose-p:text-gray-800 prose-p:leading-relaxed prose-a:text-blue-800 prose-img:rounded-sm" data-id="element-33">
            <p style={{
            marginBottom: '20px'
          }} data-id="element-34">
              In my eighteen years working in veterinary rehabilitation, I've
              developed what my colleagues call "aggressive skepticism" toward
              new pet products.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-35">
              I've watched the pet industry cycle through countless
              "revolutionary" arthritis treatments that turn out to be rebranded
              supplements, overpriced beds, or gadgets with zero clinical
              backing.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-36">
              So when Dr. Jennifer Park—a colleague I respect—started talking
              about thermal reflection pads at a rehabilitation conference last
              March, my response was immediate:
            </p>

            <p className="font-serif italic pl-4 border-l-4 border-gray-300 text-gray-600" style={{
            marginBottom: '20px'
          }} data-id="element-37">
              "Jen, please tell me you're not falling for heated bed marketing."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-38">
              "They're not heated," she said. "They reflect the dog's own body
              heat back to their joints. Completely passive. No electricity."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-39">
              "So... expensive blankets?"
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-40">
              "I thought the same thing. But I've been using them with my
              chronic arthritis patients for six months. Dogs who've been
              struggling to get up, climb stairs, even play again—they're moving
              like they did a year ago. Consistently."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-41">
              That got my attention. Dogs climbing stairs again after months of
              refusal isn't placebo. It's measurable functional improvement.
            </p>

            {/* Key Points Box */}
            <div className="my-10 bg-[#fef9e7] border-y-4 border-[#d4a574] p-6 md:p-8 shadow-sm" data-id="element-42">
              <h3 className="text-xl font-bold uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-43">
                <AlertTriangle className="w-5 h-5 text-[#d4a574]" data-id="element-44" />
                Investigation Key Points
              </h3>
              <ul className="space-y-3" data-id="element-45">
                {["Medications work systemically but can't address external inflammation from heat loss", 'Electric heated pads can worsen joint inflammation despite feeling soothing', 'Thermal reflection prevents heat loss without electricity or overheating', 'Most thermal materials compress and lose effectiveness within weeks', 'Only one brand maintained thermal properties after 8 months of testing', 'Rehabilitation facilities have used this passive technology for 15+ years'].map((point, i) => <li key={i} className="flex items-start gap-3 text-base md:text-lg" data-id="element-46">
                    <CheckCircle className="w-5 h-5 text-green-700 mt-1 shrink-0" data-id="element-47" />
                    <span data-id="element-48">{point}</span>
                  </li>)}
              </ul>
            </div>

            <h2 className="text-2xl md:text-3xl mt-12 mb-6 font-bold" data-id="element-49">
              My Sister's Dog That Started My Investigation
            </h2>

            <figure className="float-right md:w-1/2 md:ml-6 mb-6 bg-white p-2 shadow-md -rotate-1" data-id="element-50">
              <img src="https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&q=80&w=600&h=400" alt="Senior Golden Retriever" className="w-full h-auto sepia-[.3]" data-id="element-51" />
              <figcaption className="text-xs text-gray-500 mt-2 font-serif italic text-center" data-id="element-52">
                Bailey, 12-year-old Golden Retriever
              </figcaption>
            </figure>
            <p style={{
            marginBottom: '20px'
          }} data-id="element-53">
              My sister Karen has a 12-year-old Golden Retriever named Bailey
              with severe hip arthritis. Bailey's on the full protocol: Librela
              injections monthly ($89 each), Adequan every 3 weeks ($65 per
              injection), Gabapentin 300mg twice daily, and $130/month in joint
              supplements.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-54">
              The medications were working—Bailey's bloodwork showed controlled
              inflammation. But every morning, Bailey took 2 minutes to stand
              up. Two full minutes of struggling, whining, legs shaking.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-55">
              She hadn't climbed the stairs to Karen's bedroom in 6 months.
              She'd stopped following Karen from room to room. Her tennis ball
              sat untouched in the corner.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-56">
              "The vet said to increase her Gabapentin," Karen told me, crying.
              "But she's already so sedated she barely moves. I don't know how
              much longer..."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-57">
              "Let me borrow Bailey for a week," I said.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200 clear-both" data-id="element-58">
              <img src="https://cdn.magicpatterns.com/uploads/38KambwGZPDjP25bvBCXEN/c636735f-d269-4055-a798-3d1295ce11ec.png" alt="FLIR thermal imaging showing temperature differential in dog joints" className="w-full h-auto" data-id="element-59" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-60">
              The Thermal Imaging Test That Changed Everything
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-61">
              I brought Bailey to my clinic the next morning with my FLIR
              thermal imaging camera—the same equipment we use to identify
              inflammation in post-surgical patients.
            </p>

            <div className="bg-gray-100 p-6 rounded-lg my-6 border-l-4 border-blue-800" data-id="element-62">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center" data-id="element-63">
                <div data-id="element-64">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-65">
                    Bailey's Body Temp
                  </div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-66">
                    101.2°F
                  </div>
                </div>
                <div data-id="element-67">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-68">
                    Floor Temp
                  </div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-69">67°F</div>
                </div>
                <div data-id="element-70">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-71">
                    Temperature Gap
                  </div>
                  <div className="text-2xl font-bold text-red-700" data-id="element-72">34.2°F</div>
                </div>
              </div>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-73">
              I watched the thermal camera as Bailey lay down. Within 4 minutes,
              the surface temperature of her hip joints dropped from 101°F to
              89°F.
            </p>

            <p className="font-bold text-xl" style={{
            marginBottom: '20px'
          }} data-id="element-74">
              Twelve degrees of heat loss in four minutes.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-75">
              I let her rest for an hour, then took another image. Her hip
              joints were 84°F—17 degrees below her core body temperature.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-76">
              Basic physics: Heat moves from warm to cold. Bailey's 101-degree
              joints were dumping therapeutic heat into my 67-degree floor for
              16+ hours every day.
            </p>

            <h2 className="text-2xl md:text-3xl mt-12 mb-6 font-bold" data-id="element-77">
              The Study That Explained Everything
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-78">
              I went home and searched "heat loss" and "cold exposure" in
              veterinary databases.
            </p>

            <div className="bg-white border border-gray-300 p-6 shadow-sm mb-8" data-id="element-79">
              <div className="font-serif font-bold text-lg mb-2" data-id="element-80">
                Journal of Pain Research, 2024
              </div>
              <h4 className="text-xl font-bold mb-4 italic" data-id="element-81">
                "Effects of Repeated Exposure to Ambient Cold on the Development
                of Inflammatory Pain in a Rat Model of Knee Arthritis"
              </h4>
              <p className="text-sm text-gray-600" style={{
              marginBottom: '20px'
            }} data-id="element-82">
                The study showed that cold exposure significantly elevated
                pro-inflammatory cytokines (IL-1β and IL-6) in arthritic joints.
                Cold temperatures literally "prime" the nervous system to
                experience arthritic pain more intensely.
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-83">
              This wasn't just discomfort—it was measurable inflammatory
              escalation triggered by temperature loss.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-84">
              Here's what I finally understood:
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-85">
              Bailey's medications WERE working systemically.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-86">
              Her bloodwork proved it—systemic inflammation was controlled.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-87">
              But medications can't prevent external inflammation.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-88">
              While Librela and Adequan reduced inflammation inside her body,
              physics was creating NEW inflammation externally every single
              night. Her joints lost 15-18 degrees of heat to cold floors during
              16 hours of sleep. That heat loss triggered localized inflammatory
              responses that her medications couldn't address—because the
              medications were fighting inflammation internally while cold
              surfaces were creating it externally.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-89">
              The medications and the physics were fighting each other.{' '}
              <strong data-id="element-90">And physics always wins.</strong>
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-91">
              This explained why her bloodwork looked good but she still
              couldn't climb stairs, play, or move normally. Her vet was
              treating the right problem with the right medications. But nobody
              was addressing the external factor overwhelming those treatments.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/6eMgqphrULC6aYsSRaSAoe/86f1a3be-0520-43a1-931f-05d39ef6c401.png" alt="Dog on electric heated pad with temperature controller" className="w-full h-auto" data-id="element-93" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-94">
              Testing Electric Heated Pads: The Inflammation Paradox
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-95">
              My first thought: If heat loss is the problem, then adding heat
              back should solve it. I bought 6 electric heated pads ($45-$180)
              and tested them on Bailey and 5 volunteer dogs (all senior, all
              with arthritis, ages 9-14).
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-96">
              Week 1 results were impressive:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-97">
              <li data-id="element-98">Dogs' joint temperatures stayed stable</li>
              <li data-id="element-99">Standing time decreased 45-60%</li>
              <li data-id="element-100">Some dogs started climbing stairs again</li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-101">
              I thought I'd solved it.
            </p>

            <h3 className="text-xl md:text-2xl mt-8 mb-4 font-bold" data-id="element-102">
              Week 2-3: The Problem Emerged
            </h3>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-103">
              Dogs who'd shown improvement in Week 1 began regressing.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-104">
              I took thermal images after they'd been on heated pads for 2
              hours:
            </p>

            <div className="bg-gray-100 p-6 rounded-lg my-6 border-l-4 border-orange-600" data-id="element-105">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-center" data-id="element-106">
                <div data-id="element-107">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-108">
                    Joint Surface Temperature
                  </div>
                  <div className="text-2xl font-bold text-orange-600" data-id="element-109">
                    108-112°F
                  </div>
                </div>
                <div data-id="element-110">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-111">
                    Dog's Natural Body Temp
                  </div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-112">101°F</div>
                </div>
              </div>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-113">
              Even on "low" settings, the pads were heating joints 7-11 degrees
              ABOVE body temperature.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-114">
              Here's what I didn't realize initially:
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-115">
              Arthritic joints are already inflamed. Inflammation creates heat.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-116">
              When you add MORE external heat—even just 7-10 degrees above body
              temperature—you're increasing inflammation in tissues that are
              already inflamed.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-117">
              <strong data-id="element-118">Short-term:</strong> Warmth feels soothing. Pain
              temporarily decreases. Dogs move better for a few days.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-119">
              <strong data-id="element-120">Long-term:</strong> Heat-inflammation cycle that worsens
              the underlying arthritis.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-121">
              A 1999 study in Pain journal confirmed this: While heat treatment
              reduced guarding behaviors short-term, temperatures above the
              therapeutic range actually increased inflammatory markers in
              arthritic joints over time.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-122">
              Additionally, the safety concerns made electric pads impractical
              for long-term use:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-123">
              <li data-id="element-124">Cord chewing risks</li>
              <li data-id="element-125">Fire hazards (2,400+ house fires annually)</li>
              <li data-id="element-126">Can't be left on overnight unsupervised</li>
              <li data-id="element-127">
                Dogs with reduced mobility can't escape if overheating occurs
              </li>
              <li data-id="element-128">$30-50/month electricity costs</li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-129">
              Electric heated pads worked initially. But they created more
              problems than they solved.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-130">
              <img src="https://cdn.magicpatterns.com/uploads/32c9sBbmDGKfDkbYGcdKo2/673f4c8b-e6b0-422e-8a14-d63bcb3e205e-ezgif.com-video-to-gif-converter.png" alt="Golden Retriever on thermal reflection pad" className="w-full h-auto" data-id="element-131" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-132">
              Discovering Thermal Reflection Technology
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-133">
              That's when I remembered emergency thermal blankets from
              wilderness medicine training—those crinkly silver sheets used for
              hypothermia.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-134">
              They don't generate heat. They reflect your own body heat back
              using a metallic layer.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-135">
              A 2009 study in Research in Veterinary Science tested reflective
              blankets (NASA-derived aluminized sheets) on dogs during surgery.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-136">
              <strong data-id="element-137">Results:</strong> Dogs wrapped in reflective materials
              maintained significantly higher body temperatures compared to
              those on active warming pads—without any external heat source.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-138">
              The reflective surface prevented "thermal drain" by bouncing
              radiant body heat back instead of letting it escape.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-139">
              I started researching thermal reflection materials designed for
              pets. Most were cheap foil-lined blankets that compressed
              immediately. <strong data-id="element-140">Then I found Endovra.</strong>
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-141">
              <img src="https://cdn.magicpatterns.com/uploads/tyFNq2raujxU1tjMFCQee2/fd018f0d-11ca-44f9-82da-dde15b055d19.png" alt="8-month canine wellness journey health tracker chart" className="w-full h-auto" data-id="element-142" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-143">
              The 8-Month Investigation Begins
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-144">
              I bought an Endovra thermal reflection pad and recruited 6 dogs
              for long-term testing:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-145">
              <li data-id="element-146">All senior dogs (9-14 years old)</li>
              <li data-id="element-147">All diagnosed with moderate to severe arthritis</li>
              <li data-id="element-148">All currently on pain medications</li>
              <li data-id="element-149">Owners ranged from ages 54-71</li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-150">
              What I measured every week for 8 months:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-151">
              <li data-id="element-152">Thermal retention (FLIR camera imaging after 1-hour rest)</li>
              <li data-id="element-153">Standing time (seconds from lying to fully standing)</li>
              <li data-id="element-154">Stair climbing ability (willingness and speed)</li>
              <li data-id="element-155">
                Activity levels (play behavior, walking distance, following
                owner)
              </li>
              <li data-id="element-156">Mobility scores (validated canine brief pain inventory)</li>
              <li data-id="element-157">Nighttime rest quality (owner sleep tracking)</li>
              <li data-id="element-158">
                Material integrity (compression, surface condition, thermal
                performance)
              </li>
            </ul>

            <h3 className="text-xl md:text-2xl mt-8 mb-4 font-bold" data-id="element-159">
              Week 1: It Works (Without The Problems)
            </h3>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-160">
              Thermal imaging results:
            </p>

            <div className="my-8" data-id="element-161">
              <div className="overflow-x-auto" data-id="element-162">
                <table className="w-full text-left border-collapse border border-gray-300" data-id="element-163">
                  <thead data-id="element-164">
                    <tr className="bg-gray-100" data-id="element-165">
                      <th className="p-3 border border-gray-300 font-bold" data-id="element-166">
                        Method
                      </th>
                      <th className="p-3 border border-gray-300 font-bold" data-id="element-167">
                        Joint Temp Effect
                      </th>
                      <th className="p-3 border border-gray-300 font-bold" data-id="element-168">
                        Outcome
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-169">
                    <tr data-id="element-170">
                      <td className="p-3 border border-gray-300" data-id="element-171">
                        Regular Floor
                      </td>
                      <td className="p-3 border border-gray-300 text-red-600" data-id="element-172">
                        Dropped 15-18°F after 1 hour
                      </td>
                      <td className="p-3 border border-gray-300" data-id="element-173">
                        Increased stiffness
                      </td>
                    </tr>
                    <tr data-id="element-174">
                      <td className="p-3 border border-gray-300" data-id="element-175">
                        Electric Heated Pads
                      </td>
                      <td className="p-3 border border-gray-300 text-orange-600" data-id="element-176">
                        Increased to 108-112°F
                      </td>
                      <td className="p-3 border border-gray-300" data-id="element-177">
                        Inflammation risk
                      </td>
                    </tr>
                    <tr className="bg-green-50" data-id="element-178">
                      <td className="p-3 border border-gray-300 font-bold" data-id="element-179">
                        Endovra Thermal Reflection
                      </td>
                      <td className="p-3 border border-gray-300 text-green-700 font-bold" data-id="element-180">
                        Maintained 99-101°F
                      </td>
                      <td className="p-3 border border-gray-300 font-bold" data-id="element-181">
                        Optimal range
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-182">
              The difference was remarkable:
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-183">
              Electric pads ADDED heat above body temperature.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-184">
              Endovra MAINTAINED heat at body temperature.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-185">
              Mobility improvements across all 6 dogs:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-186">
              <li data-id="element-187">
                <strong data-id="element-188">Standing time:</strong> Decreased 42-58% (from 1-2
                minutes down to 10-30 seconds)
              </li>
              <li data-id="element-189">
                <strong data-id="element-190">Stair climbing:</strong> 4 out of 6 dogs who'd been
                refusing or hesitating at stairs started going up/down with
                confidence by day 5
              </li>
              <li data-id="element-191">
                <strong data-id="element-192">Activity levels:</strong> Dogs initiating play, picking
                up toys, following owners room-to-room again (behaviors absent
                for 3-8 months)
              </li>
              <li data-id="element-193">
                <strong data-id="element-194">Walking distance:</strong> Owners reported 30-50% longer
                walks before dogs showed fatigue or limping
              </li>
              <li data-id="element-195">
                <strong data-id="element-196">Running/trotting:</strong> 3 dogs started light running
                during walks (first time in 4-6 months)
              </li>
              <li data-id="element-197">
                <strong data-id="element-198">Nighttime restlessness:</strong> Decreased
                dramatically—dogs stopped shifting position every 20 minutes
              </li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-199">
              Safety:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-200">
              <li data-id="element-201">No electricity = no fire risk</li>
              <li data-id="element-202">No cords to chew</li>
              <li data-id="element-203">
                No overheating possible (can't exceed dog's natural body temp)
              </li>
              <li data-id="element-204">Safe for 24/7 use</li>
              <li data-id="element-205">No ongoing costs</li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-206">
              By day 7, owner feedback was consistent:
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-207">
              "He followed me upstairs this morning. I almost cried."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-208">
              "She picked up her ball and brought it to me. Haven't seen that in
              a year."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-209">
              "He's running to the door when I grab the leash. He used to just
              look at me."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-210">
              But I've been in this industry long enough to know: Week 1
              performance doesn't predict long-term reliability.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-211">
              <img src="https://cdn.magicpatterns.com/uploads/jod74pbyYW7LRXLGn2R3YW/19d77a63-3ca9-4a0b-9335-355854bc66bd.png" alt="Multiple dogs on thermal reflection pads in veterinary rehabilitation facility" className="w-full h-auto" data-id="element-212" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-213">
              Month 2-8: Watching For Failure
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-214">
              I've tested hundreds of pet products. Most fail the same way:
              materials compress, effectiveness degrades, benefits disappear.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-215">
              I expected the same from Endovra.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-216">
              Every week for 8 months, I tested:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-217">
              <li data-id="element-218">Surface compression (measuring loft/thickness)</li>
              <li data-id="element-219">Thermal retention (FLIR imaging)</li>
              <li data-id="element-220">Material condition (visual inspection)</li>
              <li data-id="element-221">Mobility metrics (standing time, stairs, activity)</li>
            </ul>

            <h3 className="text-xl md:text-2xl mt-8 mb-4 font-bold" data-id="element-222">
              Month 2 results:
            </h3>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-223">
              <li data-id="element-224">
                <strong data-id="element-225">Thermal retention:</strong> Still maintaining 99-101°F
              </li>
              <li data-id="element-226">
                <strong data-id="element-227">Material compression:</strong> 4-6% (minimal, expected
                settling)
              </li>
              <li data-id="element-228">
                <strong data-id="element-229">Dog mobility:</strong> All improvements sustained
              </li>
              <li data-id="element-230">
                <strong data-id="element-231">New observation:</strong> 2 dogs started playing with
                each other again (had stopped due to pain)
              </li>
            </ul>

            <h3 className="text-xl md:text-2xl mt-8 mb-4 font-bold" data-id="element-232">
              Month 4 results:
            </h3>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-233">
              <li data-id="element-234">
                <strong data-id="element-235">Thermal retention:</strong> 98-101°F (optimal
                therapeutic range)
              </li>
              <li data-id="element-236">
                <strong data-id="element-237">Material compression:</strong> 8-11% (still maintaining
                loft)
              </li>
              <li data-id="element-238">
                <strong data-id="element-239">Dog mobility:</strong> Improvements sustained and some
                continuing to improve
              </li>
              <li data-id="element-240">
                <strong data-id="element-241">Owner reports:</strong> "She's like a different dog" /
                "He has his personality back"
              </li>
            </ul>

            <h3 className="text-xl md:text-2xl mt-8 mb-4 font-bold" data-id="element-242">
              Month 8 final results:
            </h3>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-243">
              After 8 months of daily use by dogs ranging from 45-95 pounds,
              weekly washing with regular detergent:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-244">
              <li data-id="element-245">
                <strong data-id="element-246">Thermal retention:</strong> Still maintaining 99-101°F
                (no degradation)
              </li>
              <li data-id="element-247">
                <strong data-id="element-248">Material compression:</strong> 12-15% (still functional,
                no core collapse)
              </li>
              <li data-id="element-249">
                <strong data-id="element-250">Standing time:</strong> Still improved 38-52% vs.
                baseline
              </li>
              <li data-id="element-251">
                <strong data-id="element-252">Stair climbing:</strong> All 4 dogs who regained stair
                ability still using stairs daily
              </li>
              <li data-id="element-253">
                <strong data-id="element-254">Activity levels:</strong> Sustained—dogs maintaining
                play, longer walks, room-to-room following
              </li>
              <li data-id="element-255">
                <strong data-id="element-256">Owner satisfaction:</strong> 100%
              </li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-257">
              The thermal reflection was still working as effectively as day
              one. And the mobility improvements weren't fading—they were
              holding steady.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-258">
              How was this possible?
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-259">
              <img src="https://cdn.magicpatterns.com/uploads/ftfsszmjBiMZfn4e5ZpJCL/883ac63c-9d54-4a65-957d-89e9a9649875.png" alt="Dr. Sarah Mitchell reviewing research on laptop" className="w-full h-auto" data-id="element-260" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-261">
              Tracking Down The Founder
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-262">
              Endovra's website was minimal. No celebrity endorsements. No
              influencer partnerships.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-263">
              Just technical specifications and a simple origin story:
            </p>

            <p style={{
            marginBottom: '20px'
          }} className="italic pl-4 border-l-4 border-gray-300 text-gray-600" data-id="element-264">
              "Developed for use in veterinary rehabilitation facilities. Used
              in clinical settings since 2008. Now available for home use."
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-265">
              I found the founder's email on the contact page and sent a
              message.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-266">
              Twelve hours later, my phone rang.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-267">
              "Dr. Mitchell? This is Tom Richardson. I've been waiting years for
              someone in veterinary medicine to actually test these properly."
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-268">
              <img src="https://cdn.magicpatterns.com/uploads/8cEByNPUSrcgZrS59S3hvX/da5c1f78-d561-4a06-b3e2-6ae4b2762f2f.png" alt="Tom Richardson in his manufacturing facility holding a thermal reflection pad" className="w-full h-auto" data-id="element-269" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-270">
              The 58-Year-Old Biomechanical Engineer Who Solved The Problem
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-271">
              Tom Richardson wasn't a pet industry marketer.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-272">
              He was a 58-year-old biomechanical engineer who'd spent 30 years
              developing prosthetic joint materials for a medical device
              company.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-273">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-274">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-275">
                "I got into thermal pads because of my own dog. 13-year-old
                German Shepherd with hip dysplasia. I tried electric heated beds
                first—they worked for a few weeks, then his joints got worse.
                The vet said the excess heat was increasing inflammation."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-276">
              "That's exactly what I found in my testing," I said.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-277">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-278">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-279">
                "Right. So I researched what rehabilitation facilities actually
                use. They'd abandoned electric heating years ago because of the
                inflammation problem. They use passive thermal
                reflection—prevents heat loss without adding inflammatory
                external heat."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-280">
              "But why do consumer products fail so quickly?"
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-281">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-282">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-283">
                "Because they use cheap single-layer construction. I solved the
                problem using the same principles we use for medical implants
                that need to last decades."
              </p>
            </div>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-284">
              <img src="https://cdn.magicpatterns.com/uploads/kZsjM6zxR2ZhSAxRNvF8R2/QGYOF_60_Aw_U_Lvmu4k25r9_0307aa9de1.jpg" alt="Medical hip implant showing multi-layer composite engineering" className="w-full h-auto" data-id="element-285" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-286">
              The "20-Year" Hip Implant Materials
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-287">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-288">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-289">
                "You know those hip implants that last 20+ years inside human
                bodies? Constant pressure, constant heat, constant movement,
                never failing?"
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-290">
              "Yes?"
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-291">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-292">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-293">
                "That's because of multi-layer composite engineering. The outer
                layer distributes pressure. The core maintains structural
                integrity. The functional layer stays protected between them.
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-294">
                If we can keep a hip implant working inside a human body for 20
                years, why can't we keep a dog pad working for more than 6
                weeks?"
              </p>
            </div>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-295">
              <img src="https://cdn.magicpatterns.com/uploads/9mtyEPznEKDMf2CDMskNF1/0fbd25de-02a1-45c9-b8fe-dc58feebb1f1.png" alt="Four-layer composite technology visualization" className="w-full h-auto" data-id="element-296" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-297">
              The Four-Layer Composite Technology
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-298">
              Tom explained what makes Endovra different:
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-299">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-300">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-301">
                "Standard pet products use single-layer construction—foam or
                fabric with a coating. When that one layer fails, the whole
                product fails.
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-302">
                We developed four-layer composite construction:"
              </p>
            </div>

            <div className="bg-gray-800 text-white p-6 rounded-sm my-8" data-id="element-303">
              <h4 className="text-lg font-bold mb-4 uppercase tracking-widest text-[#d4a574]" data-id="element-304">
                The Four-Layer Composite Technology
              </h4>
              <div className="space-y-4" data-id="element-305">
                <div className="flex gap-4" data-id="element-306">
                  <div className="font-bold text-[#d4a574] whitespace-nowrap" data-id="element-307">
                    Layer 1
                  </div>
                  <div data-id="element-308">
                    <span className="font-bold" data-id="element-309">
                      (Top Surface): Medical-grade quilted fabric
                    </span>{' '}
                    — distributes pressure evenly, prevents hot spots, durable
                    against daily wear
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-310">
                  <div className="font-bold text-[#d4a574] whitespace-nowrap" data-id="element-311">
                    Layer 2
                  </div>
                  <div data-id="element-312">
                    <span className="font-bold" data-id="element-313">
                      (Insulation Core): High-density polyester batting
                    </span>{' '}
                    — maintains structural loft under compression, creates air
                    barrier to prevent heat transfer downward
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-314">
                  <div className="font-bold text-[#d4a574] whitespace-nowrap" data-id="element-315">
                    Layer 3
                  </div>
                  <div data-id="element-316">
                    <span className="font-bold" data-id="element-317">
                      (Thermal Reflection): Aluminum composite layer
                    </span>{' '}
                    — reflects infrared radiation (body heat) back toward
                    contact points, sandwiched between protective layers to
                    prevent degradation
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-318">
                  <div className="font-bold text-[#d4a574] whitespace-nowrap" data-id="element-319">
                    Layer 4
                  </div>
                  <div data-id="element-320">
                    <span className="font-bold" data-id="element-321">
                      (Bottom Base): Rubberized non-slip foundation
                    </span>{' '}
                    — prevents pad shifting, adds structural support, protects
                    reflective layer from ground contact
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-322">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-323">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-324">
                "The key is Layer 2. Most products use cheap polyester fill that
                compresses to 30% of original thickness within weeks. We use
                medical-grade batting that maintains 88% loft after 10,000
                compression cycles."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-325">
              "That must cost significantly more to manufacture," I said.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-326">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-327">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-328">
                "About 5-6 times more than standard materials. But it's the
                difference between a pad that works for 8 weeks and one that
                works for years."
              </p>
            </div>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-329">
              <img src="https://cdn.magicpatterns.com/uploads/h8LT4z5wSimCt73eTvNkap/3892beb0-5ce3-4682-86a6-f4762125ae41.png" alt="Specialized quilting equipment for four-layer composite construction" className="w-full h-auto" data-id="element-330" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-331">
              The $340,000 Investment
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-332">
              "This sounds expensive to manufacture," I said.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-333">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-334">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-335">
                "I mortgaged my house. $340,000 total investment. Had to buy
                specialized quilting equipment that could handle four-layer
                composite construction without crushing the reflective layer."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-336">
              "That's a significant financial risk."
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-337">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-338">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-339">
                "My wife thought I was insane. But here's what bothered me—I
                showed this technology to three major pet product manufacturers.
                Want to know what they said?"
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-340">
              "What?"
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-341">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-342">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-343">
                "Two of them said 'interesting but not profitable enough.' The
                third one was more honest: 'Why would we want products that last
                3-5 years when customers replace products every 3-4 months?'"
              </p>
            </div>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-344">
              <img src="https://cdn.magicpatterns.com/uploads/pqnWSFrZ7iB7JYfQHe1tMt/2b309086-4c74-4d84-b544-18d718f3da75.png" alt="Thermal imaging of pad showing heat retention after 17 years of use" className="w-full h-auto" data-id="element-345" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-346">
              The Test Pad That Proved Everything
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-347">
              "Tom, do you have proof this lasts as long as you claim?"
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-348">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-349">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-350">
                "Hold on."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-351">
              He returned holding a worn thermal pad.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-352">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-353">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-354">
                "This is our original prototype. Made in 2008. We've used it at
                a partner rehabilitation facility for chronic arthritis
                patients—daily use, industrial washing twice weekly—for 17
                years."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-355">
              Tom set the pad on the floor, then placed a calibrated heat source
              set to 100°F on top—matching a dog’s natural body temperature. He
              aimed his thermal camera at the setup..
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-356">
              After 2 minutes:
            </p>

            <div className="bg-gray-100 p-6 rounded-lg my-6 border-l-4 border-green-700" data-id="element-357">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center" data-id="element-358">
                <div data-id="element-359">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-360">
                    Calibrated Heat Source
                  </div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-361">100°F</div>
                </div>
                <div data-id="element-362">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-363">
                    Pad Surface (Top)
                  </div>
                  <div className="text-2xl font-bold text-green-700" data-id="element-364">98°F</div>
                </div>
                <div data-id="element-365">
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-1" data-id="element-366">
                    Floor (Below Pad)
                  </div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-367">71°F</div>
                </div>
              </div>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-368">
              After 17 years of daily use and over 1,700 wash cycles, the pad
              was still preventing heat from escaping downward.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-369">
              "This is incredible," I said.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-370">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-371">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-372">
                "This is just proper engineering."
              </p>
            </div>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-373">
              <img src="https://cdn.magicpatterns.com/uploads/oCGtzSdxLPg73Wc4TpCcfy/1cd940b2-9a44-49eb-9b63-4d3ade02f605.png" alt="Golden Retriever resting on thermal reflection pad in veterinary rehabilitation facility" className="w-full h-auto" data-id="element-374" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-375">
              Why Veterinary Rehabilitation Facilities Use These
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-376">
              "Tom, you mentioned rehabilitation facilities have used these
              since 2008?"
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-377">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-378">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-379">
                "Correct. We manufacture for 23 veterinary rehabilitation
                centers across the US. When you're managing a dog's recovery
                after a $6,000 surgery, you can't risk products that fail or
                create inflammation problems."
              </p>
            </div>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-380">
              This resonated deeply.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-381">
              I'd spent 18 years in rehabilitation. We absolutely used thermal
              management for post-surgical patients.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-382">
              But I'd never questioned why our facility abandoned electric
              heated pads in favor of passive thermal surfaces around 2009.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-383">
              Now I knew: The research showing electric heat worsens
              inflammation in arthritic joints had changed the standard of care.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-384">
              "Why don't more rehab facilities tell dog owners about these for
              home use?" I asked.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-5 my-6 rounded-r-sm" data-id="element-385">
              <p className="text-sm font-semibold text-blue-900 mb-2" data-id="element-386">
                TOM RICHARDSON:
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="text-gray-800" data-id="element-387">
                "Most don't know there's a home-use version. We only started
                selling direct to consumers in 2019. Before that, it was
                exclusively commercial medical supply."
              </p>
            </div>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-388">
              <img src="https://cdn.magicpatterns.com/uploads/qbFiRPRgzYm9NdBckDbdZ8/8be5918d-0614-4de2-a98b-97eb23311ee0.png" alt="Golden Retriever resting comfortably on thermal reflection pad in home setting" className="w-full h-auto" data-id="element-389" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-390">
              Can It Overheat?
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-391">
              "But is it safe? Can dogs overheat on thermal reflection?"
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-392">
              This was my first concern too.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-393">
              Here's what's important to understand:
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-394">
              Endovra doesn't ADD heat—it REFLECTS the dog's own body heat.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-395">
              It's physically impossible for the pad to make a dog hotter than
              their natural body temperature (101-102°F).
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-396">
              A 2024 study in veterinary research showed that increasing tissue
              temperature by 4-5°C (7-9°F) above baseline improves joint range
              of motion—but the key is CONTROLLED warming, not unregulated
              external heat.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-397">
              Thermal reflection maintains that optimal range (98-102°F)
              naturally because it can only reflect what the dog's body
              produces.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-398">
              In 8 months of testing with 6 dogs:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-399">
              <li data-id="element-400">Zero overheating incidents</li>
              <li data-id="element-401">Zero discomfort signals</li>
              <li data-id="element-402">Zero adverse events</li>
              <li data-id="element-403">Surface temperature never exceeded 101°F</li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-404">
              The only temperature problems I saw were with electric heated
              pads—because those were ADDING heat the dogs' bodies couldn't
              control.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-405">
              <img src="https://cdn.magicpatterns.com/uploads/6C2Ko7cHVi4X9LGAKMpmiM/wmremove-transformed.png" alt="Dog resting comfortably on thermal reflection pad" className="w-full h-auto" data-id="element-406" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-407">
              I Reached Out to Long-Term Endovra Owners
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-408">
              I contacted dog owners who'd been using Endovra for 1+ years:
            </p>

            <div className="bg-gray-50 p-6 rounded-sm my-6 border-l-4 border-blue-600" data-id="element-409">
              <p style={{
              marginBottom: '20px'
            }} className="italic" data-id="element-410">
                "I've had my Endovra pad for 26 months. My 110-pound Rottweiler
                uses it daily. He hadn't climbed stairs in over a year—now he
                follows me upstairs every night. I tested the pad with my own
                thermal camera from work—it still maintains his joint
                temperature at 99-101°F after 2+ years."
              </p>
              <p className="font-bold text-sm" data-id="element-411">— Robert K., Portland, Oregon</p>
              <p className="text-xs text-green-700 flex items-center gap-1 mt-1" data-id="element-412">
                <CheckCircle className="w-3 h-3" data-id="element-413" />
                Using product for 26 months ✓ Verified Purchase
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-sm my-6 border-l-4 border-blue-600" data-id="element-414">
              <p style={{
              marginBottom: '20px'
            }} className="italic" data-id="element-415">
                "As a veterinarian myself, I'm extremely skeptical of pet
                products. I bought Endovra for my own arthritic dog 19 months
                ago after his mobility declined dramatically. Within 3 weeks, he
                was playing fetch again—something he hadn't done in 8 months.
                I've tested it with thermal imaging equipment from my clinic.
                After a year and a half, it maintains the same thermal
                properties as when I first bought it. That's unheard of in this
                industry."
              </p>
              <p className="font-bold text-sm" data-id="element-416">
                — Jennifer M., DVM, Austin, Texas
              </p>
              <p className="text-xs text-green-700 flex items-center gap-1 mt-1" data-id="element-417">
                <CheckCircle className="w-3 h-3" data-id="element-418" />
                Using product for 19 months ✓ Verified Purchase
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-sm my-6 border-l-4 border-blue-600" data-id="element-419">
              <p style={{
              marginBottom: '20px'
            }} className="italic" data-id="element-420">
                "My 9-year-old Lab mix stopped going upstairs about 6 months
                before I bought this. Three weeks on Endovra, he was following
                me upstairs every night again. He's also playing with our other
                dog in the backyard—something I thought I'd never see again.
                It's been 11 months now and he's still moving great."
              </p>
              <p className="font-bold text-sm" data-id="element-421">
                — Michael T., Denver, Colorado
              </p>
              <p className="text-xs text-green-700 flex items-center gap-1 mt-1" data-id="element-422">
                <CheckCircle className="w-3 h-3" data-id="element-423" />
                Using product for 11 months ✓ Verified Purchase
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-sm my-6 border-l-4 border-blue-600" data-id="element-424">
              <p style={{
              marginBottom: '20px'
            }} className="italic" data-id="element-425">
                "I'm a former ICU nurse—I test everything. After 14 months of
                daily use and weekly washing, my dog's joint temperature stays
                within 2-3 degrees of her body temp after an hour of rest. But
                more importantly, she's walking twice as far on our daily walks
                and actually runs to greet me when I come home. Every other
                product I tested failed by month 2. This one just keeps
                working."
              </p>
              <p className="font-bold text-sm" data-id="element-426">— Linda S., RN, San Diego</p>
              <p className="text-xs text-green-700 flex items-center gap-1 mt-1" data-id="element-427">
                <CheckCircle className="w-3 h-3" data-id="element-428" />
                Using product for 14 months ✓ Verified Purchase
              </p>
            </div>

            <h2 className="text-2xl md:text-3xl mt-12 mb-6 font-bold" data-id="element-429">
              My Professional Assessment
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-430">
              After 8 months of investigation, here's what I found:
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-431">
              <strong data-id="element-432">
                Medications work systemically but can't address external
                inflammation.
              </strong>{' '}
              Research confirms that cold exposure elevates inflammatory markers
              in arthritic joints (Journal of Pain Research, 2024). Dogs on
              perfect medication protocols still struggle with stairs, play, and
              normal activity because heat loss to cold surfaces creates
              localized inflammation that medications can't prevent.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-433">
              <strong data-id="element-434">
                Electric heated pads create an inflammation paradox.
              </strong>{' '}
              While they feel soothing short-term, temperatures above 104-105°F
              can worsen inflammation in already-inflamed joints. Plus: fire
              risks, supervision requirements, and high electricity costs.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-435">
              <strong data-id="element-436">
                Thermal reflection is the safe, effective alternative.
              </strong>{' '}
              Maintains optimal joint temperature (98-102°F) without adding
              inflammatory external heat. No electricity, no cords, no
              overheating risk.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-437">
              <strong data-id="element-438">Most thermal products fail within 6-8 weeks.</strong>{' '}
              Cheap materials compress and reflective layers delaminate—but
              products still look fine externally, so owners don't realize
              they've stopped working.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-439">
              <strong data-id="element-440">Medical-grade engineering makes the difference.</strong>{' '}
              Four-layer composite construction using materials designed for
              10,000+ compression cycles separates products that work for weeks
              from products that work for years.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-441">
              <strong data-id="element-442">
                Only one company is using medical-grade materials.
              </strong>{' '}
              After 8 months of testing, Endovra maintained thermal
              effectiveness while standard products failed.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-443">
              <strong data-id="element-444">
                Rehabilitation facilities abandoned electric heating 15 years
                ago.
              </strong>{' '}
              The standard of care shifted to passive thermal reflection because
              it addresses heat loss without creating inflammation problems.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-445">
              <img src="https://cdn.magicpatterns.com/uploads/ksgLP1VfSDLC74bXetzAu2/d2e20812-ad23-4c8d-8190-95e1709df4c7.png" alt="Veterinary professional with senior dog on thermal reflection pad" className="w-full h-auto" data-id="element-446" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-447">
              My Personal Decision
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-448">
              At 62, with 18 years of veterinary rehabilitation experience, I've
              learned to be selective about what I recommend. I now own three
              Endovra pads—one for my clinic, one for my sister's dog Bailey,
              and one for my own senior dog.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-449">
              I insisted on paying full retail price—I wanted no conflicts of
              interest in this investigation.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-450">
              Bailey's results after 8 months:
            </p>

            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-451">
              <li data-id="element-452">
                <strong data-id="element-453">Standing time:</strong> Down from 2 minutes to 20
                seconds
              </li>
              <li data-id="element-454">
                <strong data-id="element-455">Stairs:</strong> Started going upstairs to follow Karen
                to bed again (hadn't done that in 6 months)
              </li>
              <li data-id="element-456">
                <strong data-id="element-457">Play behavior:</strong> Picked up her tennis ball and
                brought it to Karen—first time in 4 months
              </li>
              <li data-id="element-458">
                <strong data-id="element-459">Walking:</strong> Going on 20-minute walks again (was
                struggling with 5-minute walks)
              </li>
              <li data-id="element-460">
                <strong data-id="element-461">Running:</strong> Light trotting during walks (hadn't
                run in over a year)
              </li>
              <li data-id="element-462">
                <strong data-id="element-463">Nighttime restlessness:</strong> Eliminated—sleeping 7+
                hours straight
              </li>
              <li data-id="element-464">
                <strong data-id="element-465">Medication dosage:</strong> Unchanged—but now the
                medications work properly because external inflammation is
                controlled
              </li>
              <li data-id="element-466">
                <strong data-id="element-467">Quality of life:</strong> Completely transformed
              </li>
            </ul>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-468">
              Karen sent me a video last week of Bailey running in the backyard
              chasing a squirrel. I cried watching it.
            </p>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-469">
              All from a pad that maintains optimal joint temperature without
              adding inflammatory heat.
            </p>

            <figure className="mt-16 mb-8 bg-gray-100 p-1 rounded-sm border border-gray-200" data-id="element-470">
              <img src="https://cdn.magicpatterns.com/uploads/bqdgdbxZeim8UMop4Hthtc/Tom_(1).png" alt="Email from Tom Richardson offering special reader pricing" className="w-full h-auto" data-id="element-471" />
            </figure>

            <h2 className="text-2xl md:text-3xl mb-6 font-bold" data-id="element-472">
              How to Access Tom's Offer
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-473">
              Tom created a special page exclusively for readers of this
              investigation with significant discounts on all four sizes (Small,
              Medium, Large, Extra-Large).
            </p>

            <div className="my-10 bg-[#fef9e7] border-y-4 border-[#d4a574] p-6 md:p-8 shadow-sm text-center" data-id="element-474">
              <div className="text-xs font-bold uppercase tracking-widest text-gray-600 mb-2" data-id="element-475">
                Reader Access
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-476">
                Endovra Thermal Reflection Pad
              </h3>
              <p style={{
              marginBottom: '20px'
            }} className="text-lg mb-6" data-id="element-477">
                Special Investigation Reader Pricing Available
              </p>
              <a href="https://www.endovra.com/products/thermal-joint-relief-system" target="_blank" rel="noopener noreferrer" className="bg-[#2c5f2d] hover:bg-[#1e421f] text-white text-xl font-bold py-4 px-12 rounded-sm shadow-lg transform transition hover:-translate-y-1 flex items-center gap-3 group mx-auto" data-id="element-478">
                Access Offer
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-479" />
              </a>
              <p style={{
              marginBottom: '20px'
            }} className="text-sm mt-6" data-id="element-480">
                30-day money-back guarantee. If your dog doesn't show measurable
                improvement in standing time, stairs, activity level, or
                nighttime comfort, full refund.
              </p>
            </div>

            <h2 className="text-2xl md:text-3xl mt-12 mb-6 font-bold" data-id="element-481">
              A Final Thought From Tom
            </h2>

            <p style={{
            marginBottom: '20px'
          }} data-id="element-482">
              When I asked Tom why he does this at 58, his answer stayed with
              me:
            </p>

            <div className="bg-gray-50 p-6 rounded-sm my-6 border-l-4 border-gray-400" data-id="element-483">
              <p style={{
              marginBottom: '20px'
            }} className="italic text-lg" data-id="element-484">
                "I watched my own dog's joints get worse on electric heated beds
                before I understood the inflammation problem. Then I discovered
                an entire industry selling products designed to fail in 6-8
                weeks.
              </p>
              <p style={{
              marginBottom: '20px'
            }} className="italic text-lg" data-id="element-485">
                I had the knowledge and resources to solve it properly—using the
                same medical-grade engineering we use for devices that need to
                last decades.
              </p>
              <p className="italic text-lg" data-id="element-486">
                What kind of engineer—what kind of person—would I be if I
                didn't?"
              </p>
              <p className="font-bold text-sm mt-4" data-id="element-487">
                — Tom Richardson, Biomechanical Engineer
              </p>
            </div>
          </div>
        </article>

        {/* P.S. Sections */}
        <div className="mt-12 bg-[#fef9e7] border border-[#d4a574] p-6 rounded-sm" data-id="element-488">
          <p style={{
          marginBottom: '20px'
        }} className="font-bold" data-id="element-489">
            P.S. – If you currently use any thermal product for your dog, test
            it with an infrared thermometer (available at any hardware store for
            $15-20). Measure your floor temperature, then measure your dog's
            joint temperature after 30 minutes of rest on the product. If their
            joint temperature has dropped more than 5 degrees, the product has
            failed. If it's increased more than 5 degrees above body temp
            (101-102°F), it may be worsening inflammation.
          </p>
          <p style={{
          marginBottom: '20px'
        }} className="font-bold" data-id="element-490">
            P.P.S. – Tom Richardson personally responds to every customer email.
            When's the last time you could reach a founder directly?
          </p>
        </div>

        {/* Testimonials Section */}
        <section className="mt-16 bg-white p-8 border border-gray-200 shadow-sm" data-id="element-491">
          <h3 className="text-2xl font-serif font-bold mb-8 text-center uppercase tracking-widest" data-id="element-492">
            Verified Owner Reports
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-493">
            {[{
            text: "I've had my Endovra pad for 26 months. My 110-pound Rottweiler uses it daily. He hadn't climbed stairs in over a year—now he follows me upstairs every night.",
            author: 'Robert K., Portland, Oregon',
            time: 'Using product for 26 months'
          }, {
            text: "As a veterinarian myself, I'm extremely skeptical. I bought Endovra for my own arthritic dog 19 months ago. Within 3 weeks, he was playing fetch again. It maintains the same thermal properties as when I first bought it.",
            author: 'Jennifer M., DVM, Austin, Texas',
            time: 'Using product for 19 months'
          }, {
            text: 'My 9-year-old Lab mix stopped going upstairs about 6 months before I bought this. Three weeks on Endovra, he was following me upstairs every night again.',
            author: 'Michael T., Denver, Colorado',
            time: 'Using product for 11 months'
          }, {
            text: "I'm a former ICU nurse—I test everything. After 14 months of daily use and weekly washing, my dog's joint temperature stays within 2-3 degrees of her body temp. This one just keeps working.",
            author: 'Linda S., RN, San Diego',
            time: 'Using product for 14 months'
          }].map((testimonial, i) => <div key={i} className="bg-gray-50 p-6 rounded-sm relative" data-id="element-494">
                <div className="flex gap-1 mb-3" data-id="element-495">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-500 fill-current" data-id="element-496" />)}
                </div>
                <p className="text-gray-700 italic mb-4 text-sm leading-relaxed" style={{
              marginBottom: '20px'
            }} data-id="element-497">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-gray-200 pt-3" data-id="element-498">
                  <div className="font-bold text-sm text-gray-900" data-id="element-499">
                    {testimonial.author}
                  </div>
                  <div className="text-xs text-green-700 flex items-center gap-1 mt-1 font-medium" data-id="element-500">
                    <CheckCircle className="w-3 h-3" data-id="element-501" />
                    Verified Purchase • {testimonial.time}
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* CTA Section */}
        <section className="mt-12 bg-[#fef9e7] border-4 border-[#d4a574] p-8 md:p-12 text-center relative overflow-hidden" data-id="element-502">
          <div className="absolute top-0 left-0 bg-[#d4a574] text-white text-xs font-bold px-3 py-1 uppercase tracking-widest" data-id="element-503">
            Reader Access
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-gray-900" data-id="element-504">
            Endovra Thermal Reflection Pad
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto" style={{
          marginBottom: '20px'
        }} data-id="element-505">
            Tom created a special page exclusively for readers of this
            investigation with significant discounts on all four sizes.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-506">
            <a href="https://www.endovra.com/products/thermal-joint-relief-system" target="_blank" rel="noopener noreferrer" className="bg-[#2c5f2d] hover:bg-[#1e421f] text-white text-xl md:text-2xl font-bold py-4 px-12 rounded-sm shadow-lg transform transition hover:-translate-y-1 flex items-center gap-3 group" data-id="element-507">
              Check Availability & Pricing
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-508" />
            </a>
            <p className="text-sm text-gray-600 font-medium mt-4" style={{
            marginBottom: '20px'
          }} data-id="element-509">
              <span className="inline-flex items-center gap-1 text-green-700" data-id="element-510">
                <ShieldCheck className="w-4 h-4" data-id="element-511" /> 30-day money-back guarantee.
              </span>{' '}
              If your dog doesn't show measurable improvement, full refund.
            </p>
          </div>
        </section>

        {/* Author Bio Footer */}
        <div className="mt-16 border-t border-gray-300 pt-8 flex flex-col md:flex-row gap-8 items-start" data-id="element-512">
          <img src="https://cdn.magicpatterns.com/uploads/idVRusXKSJusmFHJbYQzeZ/29cd39da-ce5d-47f5-9f37-392f625866bf.png" alt="Dr. Sarah Mitchell" className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-sm grayscale-[20%]" data-id="element-513" />
          <div data-id="element-514">
            <h3 className="text-xl font-bold font-serif mb-2" data-id="element-515">
              About Dr. Sarah Mitchell, DVM, CCRP
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" style={{
            marginBottom: '20px'
          }} data-id="element-516">
              Dr. Sarah Mitchell is a fictional veterinary rehabilitation specialist with
              18 years of clinical experience. She oversees recovery protocols
              for dogs following ACL repairs, hip replacements, and other major
              orthopedic surgeries. Her investigative work focuses on separating
              evidence-based treatments from marketing hype in the pet wellness
              industry.
            </p>
            <p className="text-xs text-gray-500 italic" style={{
            marginBottom: '20px'
          }} data-id="element-517">
            </p>
          </div>
        </div>

        {/* Disclaimer Footer */}
        <footer className="mt-20 text-xs text-gray-500 border-t border-gray-200 pt-8 pb-12" data-id="element-518">
          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-519">
            <div data-id="element-520">
              <h5 className="font-bold text-gray-700 mb-2 uppercase tracking-wider" data-id="element-521">
                Scientific References
              </h5>
              <ol className="list-decimal pl-4 space-y-1" data-id="element-522">
                <li data-id="element-523">
                  Journal of Pain Research, 2024: "Effects of Repeated Exposure
                  to Ambient Cold on the Development of Inflammatory Pain in a
                  Rat Model of Knee Arthritis"
                </li>
                <li data-id="element-524">
                  American Journal of Veterinary Research, 2013: "Effect of warm
                  compress application on tissue temperature in healthy dogs"
                </li>
                <li data-id="element-525">
                  Research in Veterinary Science, 2009: "Intraoperative use of a
                  reflective blanket for temperature management in dogs"
                </li>
                <li data-id="element-526">
                  Pain, 1999: "Reduction of pain-related behaviors with either
                  cold or heat treatment in an animal model of acute arthritis"
                </li>
              </ol>
            </div>
            <div data-id="element-527">
              <p className="mb-4" style={{
              marginBottom: '20px'
            }} data-id="element-528">
                These statements have not been evaluated by the Food and Drug
                Administration. This product is not intended to diagnose, treat,
                cure, or prevent any disease. Individual results may vary.
                Results described in testimonials are not typical.
              </p>
              <p className="font-bold" style={{
              marginBottom: '20px'
            }} data-id="element-529">
                This is a paid advertisement for Endovra and is not an actual
                news article or blog.
              </p>
            </div>
          </div>
          <div className="text-center text-gray-400" data-id="element-530">
            © 2026 Pet Health Weekly. All Rights Reserved.
          </div>
        </footer>
      </main>
    </div>;
}